var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewchatNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.978,
    height: 20.348,
    viewBox: "0 0 20.978 20.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15661"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Op component 2",
    d: "M19.257 2.847h-2.088V.759a.759.759 0 10-1.518 0v2.088h-2.088a.759.759 0 000 1.518h2.088v2.088a.759.759 0 101.518 0V4.365h2.088a.759.759 0 000-1.518z",
    fill: "#828282"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "chat (6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M4.846 20.101a.6.6 0 00.244.047.63.63 0 00.427-.17l4.253-4.07h8a3.013 3.013 0 003.011-3.011V8.359a.617.617 0 10-1.234 0v4.538a1.779 1.779 0 01-1.777 1.777H9.519a.63.63 0 00-.427.17L5.7 18.086v-2.788a.619.619 0 00-.617-.617H3.211a1.779 1.779 0 01-1.777-1.777V4.019a1.785 1.785 0 011.777-1.784h7.278a.617.617 0 000-1.234H3.211A3.013 3.013 0 00.2 4.012v8.885a3.013 3.013 0 003.011 3.011h1.262v3.629a.616.616 0 00.373.564z",
    fill: "#828282",
    stroke: "#828282",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewchatNew);
export default __webpack_public_path__ + "static/media/newchat-new.f341c873.svg";
export { ForwardRef as ReactComponent };